import { connect } from 'react-redux';
import BigEventCard from '../components/bigEventCard/BigEventCard';

const mapStateToProps = ({ bookedEvents, bookingSearch }, { eventId }) => ({
  event: bookedEvents.events.find(({ id }) => id === eventId),
  numOfUnits: bookingSearch.numOfUnits,
  fullName: bookingSearch.fullName,
});

export default connect(mapStateToProps)(BigEventCard);
